import { FilterViewModelDiscriminator, type ProductListResultViewModel } from 'autogen/swagger/all';
import BooleanFilterMenuOpener from './BooleanFilter/BooleanFilterMenuOpener';
import BooleanStarFilterMenuOpener from './BooleanStarFilter/BooleanStarFilterMenuOpener';
import BrandFilterMenuOpener from './BrandFilter/BrandFilterMenuOpener';
import ColorFilterMenuOpener from './ColorFilter/ColorFilterMenuOpener';
import LinkFilterMenuOpener from './LinkFilter/LinkFilterMenuOpener';
import PriceFilterMenuOpener from './PriceFilter/PriceFilterMenuOpener';

export default function FilterMenuOpener({ model, ...restProps }: { model: ProductListResultViewModel['filters'][0] }) {
    return FilterViewModelDiscriminator(
        model,
        (priceModel) => <PriceFilterMenuOpener model={priceModel} {...restProps} />,
        (brandModel) => <BrandFilterMenuOpener model={brandModel} {...restProps} />,
        (boolModel) => <BooleanFilterMenuOpener model={boolModel} {...restProps} />,
        (boolStarModel) => <BooleanStarFilterMenuOpener model={boolStarModel} {...restProps} />,
        () => null, // range filter not used curr
        (colorModel) => <ColorFilterMenuOpener model={colorModel} {...restProps} />,
        (linkModel) => <LinkFilterMenuOpener model={linkModel} {...restProps} />,
        () => null
    );
}
